<template>
  <div class="top-bar">
    <button v-show="isInGame" class="home-btn" @click="$router.push('/')">
      <img src="../assets/img/icons/home.png" />
    </button>
    <TusmoLogo style="transform: scale(0.8)" />
  </div>
</template>

<script>
import TusmoLogo from "./TusmoLogo.vue";

export default {
  components: {
    TusmoLogo,
  },
  computed: {
    isInGame() {
        return this.$route.name === "game"
    }
  }
};
</script>

<style scoped>
.top-bar {
  width: 100%;
  max-width: 544px;
  margin: 8px auto 0;
  padding: 4px 16px 0;
  display: flex;
  align-items: center;
  justify-content: center; /* centre le logo */
  position: relative; /* pour positionner le bouton dedans */
}

/* bouton maison collé à gauche, avec ombre et arrondi comme l'original */
.home-btn {
  position: absolute;
  left: 16px;
  top: 50%;
  transform: translateY(-50%);
  border: none;
  background: #ffffff;
  color: #154153;
  border-radius: 16px;
  padding: 10px 14px;
  box-shadow: 0 6px 0 rgba(0, 0, 0, 0.35);
  cursor: pointer;
  touch-action: manipulation;
}

.home-btn img {
  width: 30px;
}

.top-logo {
  font-weight: 900;
  letter-spacing: 0.15em;
}
</style>